import connect from 'components/lib/connect';
import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import { ButtonTypes } from 'components/common/button';
import ConfirmOrCancelModal from 'components/common/confirm_or_cancel_modal';
import CloseModal from 'actions/modal/close_modal';
import i18n from 'scripts/i18n/i18n';
import { MessageChannelType } from 'models/conversation_message';
import RedactConversationItem from 'actions/compliance/conversation/redact_conversation_item';

function ConversationItemRedactModal(props) {
  const onSubmit = () => {
    props.onConfirm({ customerId: props.customerId, itemId: props.itemId });
  };

  return <ConfirmOrCancelModal {...props} onSubmit={onSubmit} />;
}

ConversationItemRedactModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  customerId: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
};

const ConversationItemRedactModalContainer = connect(mapStateToProps, mapExecuteToProps)(ConversationItemRedactModal);

export default ConversationItemRedactModalContainer;

function mapStateToProps({ getProvider }) {
  const modalAttrs = getProvider('modal').get();

  if (COMMENT_CHANNELS.includes(modalAttrs.channel)) {
    return {
      itemId: modalAttrs.itemId,
      customerId: modalAttrs.customerId,
      title: i18n.t('Delete from Gladly'),
      submitText: i18n.t('Delete from Gladly'),
      text:
        modalAttrs.channel === MessageChannelType.FB_COMMENT ? (
          <Trans>
            Are you sure you want to delete this comment from Gladly? It will stay on Facebook. This cannot be undone.
          </Trans>
        ) : (
          <Trans>
            Are you sure you want to delete this comment from Gladly? It will stay on Instagram. This cannot be undone.
          </Trans>
        ),
      submitButtonType: ButtonTypes.DANGER,
    };
  }

  return {
    itemId: modalAttrs.itemId,
    customerId: modalAttrs.customerId,
    title: 'Delete message',
    submitText: 'Delete message',
    text: 'Are you sure you want to delete this message? This cannot be undone.',
    submitButtonType: ButtonTypes.DANGER,
  };
}

const COMMENT_CHANNELS = [MessageChannelType.FB_COMMENT, MessageChannelType.INSTAGRAM_COMMENT];

function mapExecuteToProps(executeAction) {
  return {
    onCancel: () => {
      executeAction(CloseModal);
    },
    onConfirm: props => {
      executeAction(RedactConversationItem, props);
    },
  };
}
